import { css } from "@emotion/react";
import { EnrichedSwarovskiProductFrontendProductReview } from "@swo/storefront";
import React from "react";
import { CSS_MQ } from "../../styles/breakpoints";
import { PDPReviewReply } from "./PDPReviewReply";
import { ReviewTranslations } from "./reviewTranslations";

export const PDPReviewCommentReplies: React.FC<{
  replies: EnrichedSwarovskiProductFrontendProductReview["replies"];
  t: ReviewTranslations;
  reviewDateFormatter: (createdDateIsoString: string) => string;
}> = ({ replies, t, reviewDateFormatter }) => {
  if (replies.length === 0) {
    return null;
  }

  return (
    <div
      css={css`
        margin-left: var(--content-gutter);
        margin-top: -12px;

        ${CSS_MQ.atLeastMd} {
          margin-left: 48px;
        }
      `}
    >
      {replies.map(reply => (
        <PDPReviewReply key={reply.id} reply={reply} t={t} reviewDateFormatter={reviewDateFormatter} />
      ))}
    </div>
  );
};
